import Vue from "vue";
import VueRouter from "vue-router";
import { getInstance } from "../auth0-plugin";

import { ability } from "@/plugins/ability";

import authRoutes from "@/_auth/authRoutes";
import AdminRoutes from './app_routes/AdminRoutes'
import ClientRoutes from './app_routes/ClientRoutes'
import ProjectRoutes from './app_routes/ProjectRoutes'
import TaskRoutes from './app_routes/TaskRoutes'
import AgendaRoutes from './app_routes/AgendaRoutes'
import EmployeeRoutes from './app_routes/EmployeeRoutes'
import DocumentRoutes from './app_routes/DocumentRoutes'
import TemplateRoutes from './app_routes/TemplateRoutes'
import MovementRoutes from './app_routes/MovementRoutes'

Vue.use(VueRouter);

const routes = [
  ...authRoutes,
  {
    path: "/",
    name: "Home",
    component: () => import("../pages/Home.vue"),
    meta: {
      auth: true
    }
  },
  ...AdminRoutes,
  ...ClientRoutes,
  ...ProjectRoutes,
  ...TaskRoutes,
  ...AgendaRoutes,
  ...EmployeeRoutes,
  ...DocumentRoutes,
  ...TemplateRoutes,
  ...MovementRoutes,

  {
    path: '*',
    name: 'Err404',
    component: () => import('../pages/Err404.vue'),
  },
];


Vue.router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

Vue.router.beforeEach(async(to, from, next) => {
  document.title = 'AZO'
  next()
//   // if (!store.state.User.oneUser && localStorage.auth_token_default){
//   //   // await Vue.prototype.$auth.fetch()
//   // }
//   // if (store.state.User.oneUser && to.meta.roles && to.meta.roles.includes(store.state.User.oneUser.employee.role)){
//   //   next()
//   // } else if(!to.meta.roles){
//   //   next()
//   // } else{
//   //   let noti = {
//   //     type: 'error',
//   //     msg: 'Você não tem permissão para acessar esse recurso'
//   //   }
//   //   store.dispatch('Notification/add', noti)
//   //   console.log('vai nao');
//   //   next('/')
//   // }
//   // next()
})


async function Auth0Guard (to, from, next) {
  document.title = 'AZO'
  const auth0 = getInstance()

  const delay = ms => new Promise(res => setTimeout(res, ms));

  const evaluatePermission = async () => {

    const ability_is_loaded = ability && ability.rules.length

    if (to.meta.permission && ability_is_loaded){
      const {act, on} = to.meta.permission
      // console.log('CAN? ', ability.can(act, on));
      return ability.can(act, on)

    } else if (to.meta.permission && !ability_is_loaded) {
        await delay(1000);
        console.log('DISPAROU NOVAMENTE')
        return await evaluatePermission()

      } else {
      return true
    }

  }

  const guardAction = async () => {
    //console.log({to});
    if( !to.meta || !to.meta.auth){
      if (to.meta.auth == false && auth0.isAuthenticated ){
        next('/')
      } else {
        next()
      }
    }else{
      if(auth0.isAuthenticated){
        const evaluation = await evaluatePermission()

        if (evaluation){
          next()
        }
        else {
          alert('Desculpe, mas parece que você não possui permissão para acessar esse recurso.')
          const is_reload = from === VueRouter.START_LOCATION
          if (is_reload){
            next('/')
          }
        }
      }else{
        next('/login')
      }
    }
  };
  if (!auth0.isLoading) {
    return guardAction();
  }
  auth0.$watch("isLoading", (isLoading) => {
    if (isLoading === false) {
      return guardAction();
    }
  });
}




Vue.router.beforeResolve((to, from, next) => {
  Auth0Guard(to, from, next)
})

export default Vue.router;